import { withRouter } from "react-router-dom";
import CallCenter from "../../components/auth/CallCenter";
import CompanyDetails from "../../components/CompanyDetails";

const CompanyDetailcallcenter = (props) => {
  const company = props.location.state;
  return (
    <CallCenter>
      <CompanyDetails companyData={company} />
    </CallCenter>
  );
};

export default withRouter(CompanyDetailcallcenter);
